import { defineMessages } from 'react-intl';

export const navV3Messages = defineMessages({
  home: {
    defaultMessage: 'Home',
    id: 'VJZhZGLhA5',
    description: 'Sidebar entry and panel title for the Agent Home navigation',
  },
  hideHomeNavigation: {
    defaultMessage: 'Hide Home navigation',
    id: 'JUr7VwuxwO',
    description: 'Accessible label for collapsing the Home navigation panel',
  },
  showHomeNavigation: {
    defaultMessage: 'Show Home navigation',
    id: 'c1k/p3P9BI',
    description: 'Accessible label for expanding the Home navigation panel',
  },
  newChat: {
    defaultMessage: 'New chat',
    id: '1OP+Qrrz9f',
    description: 'Nav-v3 sidebar entry that starts a new Heidi Work chat',
  },
  routines: {
    defaultMessage: 'Routines',
    id: '2FD3MXx0u5',
    description: 'Nav-v3 sidebar entry opening the Routines (workflows) surface',
  },
  evidence: {
    defaultMessage: 'Evidence',
    id: 'OA/K2JLJQu',
    description:
      'Nav-v3 sidebar entry opening Work home with the Evidence composer pill selected',
  },
  library: {
    defaultMessage: 'Library',
    id: '6MLdhKIYjr',
    description: 'Nav-v3 sidebar entry opening the Evidence library',
  },
  tasks: {
    defaultMessage: 'Tasks',
    id: 'jf866TZpD1',
    description: 'Nav-v3 sidebar entry opening the clinical tasks page',
  },
  recents: {
    defaultMessage: 'Recents',
    id: 'gPWU6VN558',
    description:
      'Nav-v3 sidebar section header for the merged recent visits and chats list',
  },
  pinned: {
    defaultMessage: 'Pinned',
    id: 'HbdcehFm/H',
    description:
      'Nav-v3 sidebar section header for pinned (backend: saved) chats, shown above Recents',
  },
  pinnedShowLess: {
    defaultMessage: 'Show less',
    id: '1xa8Zio5OD',
    description: 'Nav-v3 sidebar collapse pinned list',
  },
  pinnedShowMore: {
    defaultMessage:
      '{count, plural, =0 {Show more} one {Show more (#)} other {Show more (#)}}',
    id: 'UhCNb0hCr+',
    description: 'Nav-v3 sidebar expand pinned list',
  },
  chatRowPin: {
    defaultMessage: 'Pin',
    id: 'fNAX/4Nuyz',
    description: 'Nav-v3 chat row action menu: pin the chat (backend: save)',
  },
  chatRowUnpin: {
    defaultMessage: 'Unpin',
    id: 'eYU+QaV1+t',
    description: 'Nav-v3 chat row action menu: unpin the chat (backend: unsave)',
  },
  chatRowRename: {
    defaultMessage: 'Rename',
    id: 'CxDTEIGmWw',
    description:
      'Nav-v3 chat row action menu: rename the chat, and accessible label for the inline rename input',
  },
  chatRowDeleteDialogTitle: {
    defaultMessage: 'Delete chat?',
    id: 'BI/WqemhKf',
    description: 'Nav-v3 chat row delete confirmation dialog title',
  },
  chatRowDeleteDialogDescription: {
    defaultMessage:
      'This action cannot be undone. This will permanently delete the chat.',
    id: 'lMugPquF2y',
    description: 'Nav-v3 chat row delete confirmation dialog body',
  },
  chatRowDeleteDialogCancel: {
    defaultMessage: 'Cancel',
    id: 'LvZ029bDMC',
    description: 'Nav-v3 chat row delete confirmation dialog cancel button',
  },
  chatRowDeleteDialogConfirm: {
    defaultMessage: 'Delete',
    id: 'y5eNqaNH8n',
    description:
      'Nav-v3 chat row delete confirmation dialog confirm button, and the chat row action menu destructive delete item',
  },
  chatRowDeleteDialogDeleting: {
    defaultMessage: 'Deleting...',
    id: 'chXYCr5CDG',
    description:
      'Nav-v3 chat row delete confirmation dialog confirm button while the delete mutation is pending',
  },
  chatRowCopyChatId: {
    defaultMessage: 'Copy chat ID',
    id: 'IU5n7mmh8z',
    description: 'Nav-v3 chat row action menu: copy the chat id to the clipboard',
  },
  chatRowChatIdCopied: {
    defaultMessage: 'Chat ID copied',
    id: 'ij+zg2oh5u',
    description: 'Toast shown after copying a chat id from the nav-v3 chat row menu',
  },
  chatRowCopyFailed: {
    defaultMessage: 'Could not copy to clipboard',
    id: 'CEn6vXE0s9',
    description: 'Toast shown when copying a chat id from the nav-v3 chat row menu fails',
  },
  chatRowDeleteFailed: {
    defaultMessage: 'Could not delete chat',
    id: 'm4sJC3vwIS',
    description:
      'Toast shown when deleting a Work (v2) chat from the nav-v3 chat row menu fails',
  },
  chatRowMoreActions: {
    defaultMessage: 'More actions',
    id: 'E11xSPHl0L',
    description: 'Accessible label for the nav-v3 chat row ellipsis action menu trigger',
  },
  filterRecents: {
    defaultMessage: 'Filter recents',
    id: '4j5SS9E1az',
    description:
      'Accessible label for the Recents header three-dot action that opens the All/Chats/Sessions filter menu',
  },
  filterAll: {
    defaultMessage: 'All',
    id: '/CKqfbhKVI',
    description: 'Recents filter menu option that shows both chats and sessions',
  },
  filterChats: {
    defaultMessage: 'Chats',
    id: 'RM53FW0aCv',
    description: 'Recents filter menu option that shows only chat rows',
  },
  filterEncounters: {
    defaultMessage: 'Sessions',
    id: 'T1z7tFPXPf',
    description: 'Recents filter menu option that shows only visit/session rows',
  },
  searchRecents: {
    defaultMessage: 'Search recents',
    id: 'HxyKd+N6ST',
    description:
      'Accessible label for the Recents header action that opens the inline search field',
  },
  recentsSearchPlaceholder: {
    defaultMessage: 'Search chats and sessions',
    id: 'c5yROVmOzq',
    description: 'Placeholder and accessible label for the Recents inline search input',
  },
  recentsSearchClear: {
    defaultMessage: 'Clear search',
    id: 'prE1GxgAWu',
    description: 'Accessible label for the Recents inline search clear action',
  },
  recentsSearchClose: {
    defaultMessage: 'Close search',
    id: 'TCfO1INFf9',
    description:
      'Accessible label for the Recents header close action that exits search and restores the heading, Search action, and three-dot filter action',
  },
  selectedVisit: {
    defaultMessage: 'Selected visit: {name}',
    id: 'KtEb9R9+3S',
    description: 'Accessible label for the active Recent Visits row',
  },
  context: {
    defaultMessage: 'Context',
    id: '0q594Zsmw0',
    description: 'Nav-v3 recent-visit fragment linking to the session context tab',
  },
  noteFallback: {
    defaultMessage: 'Note',
    id: 'Y9GtXHoQQZ',
    description:
      'Nav-v3 recent-visit fragment label for the consult note when it has no heading',
  },
  loadMore: {
    defaultMessage: 'Load more',
    id: 'c2w9gxmayp',
    description: 'Nav-v3 button loading more recent chats',
  },
  recentsSearchNoResults: {
    defaultMessage: 'No results found',
    id: 'Pc/GZq/egX',
    description:
      'Recents search empty state shown once every relevant source has settled with no matches',
  },
  recentsSearchError: {
    defaultMessage: 'Couldn’t load results',
    id: 'M09wYONfSi',
    description: 'Recents search error shown when a relevant source fails',
  },
  recentsSearchRetry: {
    defaultMessage: 'Try again',
    id: 'iYmaKLf995',
    description: 'Action that retries failed Recents search requests',
  },
  recentsGroupToday: {
    defaultMessage: 'Today',
    id: 'sHmlK38SoZ',
    description: 'Recents sidebar date section header for items from today',
  },
  recentsGroupYesterday: {
    defaultMessage: 'Yesterday',
    id: 'TDbXcECpWK',
    description: 'Recents sidebar date section header for items from yesterday',
  },
  recentsGroupLast7: {
    defaultMessage: 'Last 7 days',
    id: 'SNN4/BGz6A',
    description:
      'Recents sidebar date section header for items from two to seven calendar days ago',
  },
  recentsGroupOlder: {
    defaultMessage: 'Older',
    id: 'QcunG3k9To',
    description: 'Recents sidebar date section header for items older than seven days',
  },
  expandRecentsDateGroup: {
    defaultMessage: 'Expand {section}',
    id: 'HGE1811DOP',
    description:
      'Accessible label for expanding a collapsed Recents sidebar date section',
  },
  collapseRecentsDateGroup: {
    defaultMessage: 'Collapse {section}',
    id: 'D/mdTflJcP',
    description:
      'Accessible label for collapsing an expanded Recents sidebar date section',
  },
  untitledSession: {
    defaultMessage: 'Untitled session',
    id: 'Y+NHa5cE6L',
    description: 'Fallback label for a recent visit with no gist or session name',
  },
  homePreviewLabel: {
    defaultMessage: 'Home preview',
    id: 'KkCNbx2vm7',
    description:
      'Accessible name for the Home hover/focus preview popover anchored to the primary Home nav item',
  },
});
